<div id="Area-MainActions">
  <ng-container *ngIf="actions" [ngTemplateOutlet]="actions.templateRef"></ng-container>
</div>
<div id="Area-WorkZone">
  <ng-container *ngIf="workspace" [ngTemplateOutlet]="workspace.templateRef"></ng-container>
</div>
